const DBPREFIX = 'haomai'

class Store {
  constructor () {
    this.store = window.sessionStorage
    this.prefix = DBPREFIX

    this.staticName = {
      USER_TOKEN: 'user_token',
      SYSTEM_TYPE: 'system_type',
      POINT_ID: 'point_id', // 点位id(解码后的)
      EN_POINT_ID: 'en_point_id', // 点位id(解码后的)
      USER_INFO: 'user_info',
      ACCESS_OPENID: 'access_openid',
      LOCAL_URL: 'local_url', // 打开需要去的页面
      NONCESTR: 'wx_my_nonce',
      APPID: 'wx_my_app_id',
      TIME_STAMP: 'wx_my_time_stamp',
      SIGNATURE: 'my_signature',
      USER_AUTH: 'user_auth',
      WX_TOKEN: 'wx_token', // 在小程序页面生成的唯一码s
      TODAY_POINT_GOODS: 'today_point_goods', // 点位商品
      TODAY_STORE_LIST: 'today_store_list',
      STORE_INFO: 'store_info', // 店铺对应的id
      EN_STORE_ID: 'en_store_id',
      ACTIVITY_LIST: 'activity_list',
      ISNOTSUPORTSCAN: 'is_not_suport_scan', // 微信是否支付扫一扫
      WXMINI_CODE: 'wexin_code',
      WEIXIN_USERINFO: 'weixin_user_info', // 微信公众号返回的用户信息
      CITY_CODE: 'wx_city_code',
      IS_NOT_ABLE_USER: 'is_not_able',
      RECORDS_IFNO: 'records_info',
      URL_HISTORY: 'url_history',
      UTM_PARAM: 'utm_param',
      HOST_INFO: 'host_info' // 打开页面的渠道，包括 微信(wx)、支付宝(ali)、Today APP(app)、web浏览器以及其它APP(other)
    }
  }

  set (key, value, fn) {
    try {
      value = JSON.stringify(value)
    } catch (e) {

    }
    this.store.setItem(this.prefix + key, value)

    fn && fn()
  }

  get (key, fn) {
    if (!key) {
      throw new Error('没有找到key。')
    }
    if (typeof key === 'object') {
      throw new Error('key不能是一个对象。')
    }
    var value = this.store.getItem(this.prefix + key)
    if (value !== null) {
      try {
        value = JSON.parse(value)
      } catch (e) {

      }
    }
    if (value !== null) {
      try {
        value = JSON.parse(value)
      } catch (e) {

      }
    }
    return value
  }

  remove (key) {
    this.store.removeItem(this.prefix + key)
  }

  isNeedAuth () {
    // 是否需要实名验证
    return this.get(this.staticName.USER_AUTH)
  }
}

export default new Store()



// WEBPACK FOOTER //
// ./src/utils/tools/store.js